import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import ClearCache from "./ClearCache";
import Cookies from "universal-cookie";

import './index.css';
import * as serviceWorker from './serviceWorker';
import './assets/css/_plugin-perfect-scrollbar.css';
import './assets/css/_plugin-react-table.css';
import NotFound from './pages/NotFound';
import Maintenance from './pages/Maintenance';
import RegisterPage from './pages/RegisterPage';

import CountryList from "./assets/dictionary/CountryIso3Code.csv";

// const Home = React.lazy(() => import('./pages/Home'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const InternalProfileSearch = React.lazy(() => import('./pages/InternalProfileSearch'));
const ProtectedRoute = React.lazy(() => import('./components/ProtectedRoute'));
const RetailHome = React.lazy(() => import('./pages/Home'));
const hist = createBrowserHistory();

const maintenance = false;
const cookies = new Cookies('themeColor', 'light', { path: '/' });
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabName: null,
            cookiesChanged: false,
            CountryCodeList: [],
        };
    }
    componentDidMount() {
        this.getCountryIso();
        cookies.addChangeListener(event => {
            this.setState({ cookiesChanged: !this.state.cookiesChanged });
        });
    }
    getLandingTab = (tabName) => {
        this.setState({ tabName });
    }
    setCookiesChanged = () => {
        this.setState({ cookiesChanged: !this.state.cookiesChanged });
    }
    getCountryIso() {
        var request = new XMLHttpRequest();
        request.open("GET", CountryList, false);
        request.send(null);

        let csvData = [];
        var jsonObject = request.responseText.split(/\r?\n|\r/);
        for (var i = 0; i < jsonObject.length; i++) {
            let country = jsonObject[i].split(/,(?=(?:(?:[^"]*(?:")){2})*[^"]*$)/);
            csvData.push({ code: country[0], name: country[1] ? country[1].replace(/["]+/g, "") : null });
        }
        this.setState({ CountryCodeList: csvData });
    }
    render() {
        return (
            <ClearCache>
                {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                    if (loading) return null;
                    if (!loading && !isLatestVersion) {
                        refreshCacheAndReload();
                    }
                    return (
                        !maintenance ?
                            <React.Suspense fallback={<span></span>}>
                                <Router history={hist}>
                                    <Switch>
                                        <Route path="/register" render={(props) => <RegisterPage {...props} cookies={cookies} setCookiesChanged={this.setCookiesChanged} componentMode={'register'} getLandingTab={this.getLandingTab} CountryCodeList={this.state.CountryCodeList} />} />
                                        <Route path="/loginPage" render={(props) => <LoginPage {...props} cookies={cookies} setCookiesChanged={this.setCookiesChanged} componentMode={'login'} getLandingTab={this.getLandingTab} />} />
                                        <Route path="/changePassword" render={(props) => <LoginPage {...props} cookies={cookies} setCookiesChanged={this.setCookiesChanged} componentMode={'changePassword'} />} />
                                        <Route path="/forgotPassword" render={(props) => <LoginPage {...props} cookies={cookies} setCookiesChanged={this.setCookiesChanged} componentMode={'forgotPassword'} />} />
                                        <Route path="/password_reset" render={(props) => <LoginPage {...props} cookies={cookies} setCookiesChanged={this.setCookiesChanged} componentMode={'resetForgottenPassword'} />} />
                                        <Route path="/signout" render={(props) => <RetailHome {...props} cookies={cookies} setCookiesChanged={this.setCookiesChanged} tabName={this.state.tabName ? this.state.tabName : ""} />} />
                                        <ProtectedRoute path="/_internalSearch" component={InternalProfileSearch} role={'INTERNAL_LOOKUP'} />
                                        <Route path="/" render={(props) => <RetailHome {...props} cookies={cookies} setCookiesChanged={this.setCookiesChanged} tabName={this.state.tabName ? this.state.tabName : ""} />} />
                                        <Redirect from="/" to="/home" />
                                        <Route path="*" component={NotFound} />
                                    </Switch>
                                </Router>
                            </React.Suspense>
                            :
                            <React.Suspense fallback={<span></span>}>
                                <Router history={hist}>
                                    <Switch>
                                        <Route path="/" component={Maintenance} />
                                        <Route path="*" component={Maintenance} />
                                    </Switch>
                                </Router>
                            </React.Suspense>
                    )
                }}
            </ClearCache>
        )
    }
}

ReactDOM.render(
    <App />,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
